module.exports = __webpack_public_path__ + "8bf4ed3ed6649b7630fbf8d4785d35a3.svg";